import type { MouseEvent } from 'react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import {
  PromoMaterialLandingPageDto,
  PromoMaterialLandingPageKey,
} from 'api/ClientArea/PromoMaterialDto'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const PromoMaterialActiveCell = (props: GridCellProps) => {
  const enabled = props.dataItem.enabled || false

  return (
    <td width={80} style={{ textAlign: 'center' }}>
      <Badge variant={enabled ? 'outline-info' : 'neutral'}>{enabled ? 'Yes' : 'No'}</Badge>{' '}
    </td>
  )
}

const createPromoMaterialNameCell = (onEdit: (data: PromoMaterialLandingPageDto) => void) => {
  return (props: GridCellProps) => {
    const name = props.dataItem.name

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      onEdit(props.dataItem)
    }

    return (
      <td className='table-columns__content' style={{ textAlign: 'left' }}>
        <Button
          type='button'
          variant='link'
          onMouseDown={(event) => event.stopPropagation()}
          onClick={handleClick}
        >
          {name}
        </Button>
      </td>
    )
  }
}

export const promoMaterialColumn = (
  onEdit: (data: PromoMaterialLandingPageDto) => void
): GridColumn[] => [
  {
    title: 'Name',
    field: PromoMaterialLandingPageKey.name,
    cell: createPromoMaterialNameCell(onEdit),
    show: true,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'Size',
    field: PromoMaterialLandingPageKey.size,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 120,
  },
  {
    title: 'Category',
    field: PromoMaterialLandingPageKey.category,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 120,
  },
  {
    title: 'Type',
    field: PromoMaterialLandingPageKey.type,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 120,
  },
  {
    title: 'Active',
    field: PromoMaterialLandingPageKey.active,
    cell: PromoMaterialActiveCell,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 80,
    minResizableWidth: 80,
  },
]
